import { render, staticRenderFns } from "./ModalCenter.vue?vue&type=template&id=406a7e37&"
import script from "./ModalCenter.vue?vue&type=script&lang=js&"
export * from "./ModalCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports